<div id="pubblicita-inpage-0" class="pubblicita" [hidden]="!isShow()">
    <mat-icon class="material-symbols-outlined x-inpage dn-icon" (click)="closeInpageCmp()">
        close
    </mat-icon>

    <h3 class="pubblicita-inpage">pubblicità</h3>
</div>

<div [hidden]="!isShow()" #divVideoContainer>
    <!-- Il contenuto video sarà inserito dinamicamente via JavaScript -->
</div>
